<ng-container *transloco="let t">

    <div class="d-flex flex-wrap justify-content-between mb-3 gap-2 align-items-center">
        <div class="d-flex align-items-center flex-wrap gap-2">
            <!-- Search -->
            @if (showSearchBar) {
            <div class="search-wrapper">
                <app-search
                        (searchQuery)="handleInput($event)"
                        [inputValue]="searchText"
                        [placeholder]="t('search.placeholder.races')"/>
            </div>
            }
            <ng-container *ngFor="let group of groups">
                <div class="pe-0 pe-md-1 pe-lg-0">
                    <app-filter-item
                            [requiredAny]="group.requiredAny ?? false"
                            [title]="t(group.labelKey)"
                            [id]="group.queryParam + 'Filter'"
                            [type]="group.type"
                            [allowSearchItems]="group.allowSearching ?? false"
                            [items]="group.items"
                            [showSelectionAsLabel]="group.showSelectionAsLabel"
                            (onChange)="toggle(group, $event)"/>
                </div>
            </ng-container>
        </div>

        <div class="filter-trailing">
            <ng-content select="[slot='filterTrailing']"></ng-content>
        </div>
    </div>

</ng-container>